import { LitElement, html, svg } from 'lit';

export class IconChevronLeft24 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15 19.5 7.5 12 15 4.5"></path></svg>`; }
}
if (!customElements.get('f-icon-chevron-left24', IconChevronLeft24)) {
  customElements.define('f-icon-chevron-left24', IconChevronLeft24);
}